import "./App.css";
import { ProtectedRoute } from "./Components/Pages/ProtectedRoute.jsx";
import { Login } from "./Components/Signup/Login";
import { Signup } from "./Components/Signup/Signup";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Home } from "./Home";
import { useState, createContext, useEffect } from "react";
import OTPPassword from "./Components/Signup/OTPPassword";
import ResetPassword from "./Components/Signup/ResetPassword";
import { EmailPassword } from "./Components/Signup/EmailPassword";
import { ImportAccount } from "./Components/Pages/ImportAccount";

import { Analyse } from "./Components/LeftBar/Analyse.jsx";
import { Book } from "./Components/LeftBar/Book.jsx";
import { Collection } from "./Components/LeftBar/Collection.jsx";
import { GameReview } from "./Components/LeftBar/GameReview.jsx";
import { More } from "./Components/LeftBar/More.jsx";
import { Notes } from "./Components/LeftBar/Notes.jsx";
import { Puzzles } from "./Components/LeftBar/Puzzles.jsx";
import { Settings } from "./Components/LeftBar/Settings.jsx";
import { Social } from "./Components/LeftBar/Social.jsx";
import { Subscription } from "./Components/LeftBar/Subscription.jsx";
import { Visualisation } from "./Components/LeftBar/Visualisation.jsx";
import { WhoIsWinning } from "./Components/LeftBar/WhoIsWinning.jsx";
import { Profile } from "./Components/Pages/Profile.jsx";
import { Points } from "./Components/Pages/Points.jsx";
import { CasualPuzzles } from "./Components/Pages/CasualPuzzles.jsx";
import { PersonalisedPuzzles } from "./Components/Pages/PersonalisedPuzzles.jsx";
import { ClassicalPuzzles } from "./Components/Pages/ClassicalPuzzles.jsx";
import { GameArchive } from "./Components/Pages/GameArchive.jsx";
import { DailyPuzzle } from "./Components/Pages/DailyPuzzle.jsx";
import { Stats } from "./Components/Pages/Stats.jsx";
import { PuzzleRush } from "./Components/Pages/PuzzleRush.jsx";
import { PuzzleBattle } from "./Components/Pages/PuzzleBattle.jsx";
import { Bot } from "./Components/Pages/Bot.jsx";
import { Compare } from "./Components/Pages/Compare.jsx";
import PuzzleAnalysis from "./Components/Pages/PuzzleAnalysis";
import SmartPuzzles from "./Components/Pages/SmartPuzzles.jsx";
import TopGamePuzzles from "./Components/Pages/TopGamePuzzles.jsx";
import VisualisationPuzzles from "./Components/Pages/VisualisationPuzzles.jsx";
import { NotFound } from "./Components/Pages/NotFound.jsx";

export const RecoveryContext = createContext();
function App() {
  const [email, setEmail] = useState("");
  const [fromSignup, setFromSignup] = useState(true);

  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [currentFen, setCurrentFen] = useState(() => {
    const savedFen = sessionStorage.getItem("currentFen");
    return savedFen || "";
  });
  const [initialOrientation, setInitialOrientation] = useState("white");
  const isAuthenticated = Boolean(
    localStorage.getItem("token") || sessionStorage.getItem("token")
  );

  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem("currentFen", currentFen);
  }, [currentFen]);

  return (
    <div>
      <BrowserRouter>
        <RecoveryContext.Provider
          value={{
            email,
            setEmail,
            fromSignup,
            setFromSignup,
            fname,
            setFname,
            lname,
            setLname,
            username,
            setUsername,
            password,
            setPassword,
            currentFen,
            setCurrentFen,
            initialOrientation,
            setInitialOrientation,
          }}
        >
          <Routes>
            {}
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path={"/signup"} element={<Signup />}></Route>
            <Route path={"/login"} element={<Login />}></Route>
            <Route path="/OTPPassword" element={<OTPPassword />} />
            <Route path={"/ResetPassword"} element={<ResetPassword />} />
            <Route path={"/EmailPassword"} element={<EmailPassword />} />

            {}
            {}

            <Route
              path={"/home"}
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            ></Route>
            <Route
              path={"/ImportAccount"}
              element={
                <ProtectedRoute>
                  <ImportAccount />
                </ProtectedRoute>
              }
            />

            {}
            <Route
              path={"/Analyse"}
              element={
                <ProtectedRoute>
                  <Analyse />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/Book"}
              element={
                <ProtectedRoute>
                  <Book />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/Collection"}
              element={
                <ProtectedRoute>
                  <Collection />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/GameReview"}
              element={
                <ProtectedRoute>
                  <GameReview />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/More"}
              element={
                <ProtectedRoute>
                  <More />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/Notes"}
              element={
                <ProtectedRoute>
                  <Notes />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/Puzzles"}
              element={
                <ProtectedRoute>
                  <Puzzles />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/Settings"}
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/Social"}
              element={
                <ProtectedRoute>
                  <Social />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/Subscription"}
              element={
                <ProtectedRoute>
                  <Subscription />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/Visualisation"}
              element={
                <ProtectedRoute>
                  <Visualisation />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/WhoIsWinning"}
              element={
                <ProtectedRoute>
                  <WhoIsWinning />
                </ProtectedRoute>
              }
            />

            {}
            <Route
              path={"/Profile"}
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/Points"}
              element={
                <ProtectedRoute>
                  <Points />
                </ProtectedRoute>
              }
            />

            {}
            <Route
              path={"/CasualPuzzles"}
              element={
                <ProtectedRoute>
                  <CasualPuzzles />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/PersonalisedPuzzles"}
              element={
                <ProtectedRoute>
                  <PersonalisedPuzzles />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/ClassicalPuzzles"}
              element={
                <ProtectedRoute>
                  <ClassicalPuzzles />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/VisualisationPuzzles"}
              element={
                <ProtectedRoute>
                  <VisualisationPuzzles />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/TopGamePuzzles"}
              element={
                <ProtectedRoute>
                  <TopGamePuzzles />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/SmartPuzzles"}
              element={
                <ProtectedRoute>
                  <SmartPuzzles />
                </ProtectedRoute>
              }
            />

            {}
            <Route
              path={"/GameArchive"}
              element={
                <ProtectedRoute>
                  <GameArchive />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/DailyPuzzle"}
              element={
                <ProtectedRoute>
                  <DailyPuzzle />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/Stats"}
              element={
                <ProtectedRoute>
                  <Stats />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/PuzzleRush"}
              element={
                <ProtectedRoute>
                  <PuzzleRush />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/PuzzleBattle"}
              element={
                <ProtectedRoute>
                  <PuzzleBattle />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/Bot"}
              element={
                <ProtectedRoute>
                  <Bot />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/Compare"}
              element={
                <ProtectedRoute>
                  <Compare />
                </ProtectedRoute>
              }
            />
            <Route
              path={"/PuzzleAnalysis"}
              element={
                <ProtectedRoute>
                  <PuzzleAnalysis />
                </ProtectedRoute>
              }
            />
            <Route
              path="*"
              element={
                isAuthenticated ? <NotFound /> : <Navigate to="/login" replace />
              }
            />
          </Routes>
        </RecoveryContext.Provider>
      </BrowserRouter>
    </div>
  );
}

export default App;
